"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberFormInput = exports.PercentFormInput = exports.PercentInput = exports.PERCENT_DEFAULT_PROPS = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var react_number_format_1 = require("react-number-format");
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var TextField_1 = require("shared/components/Form/TextField");
var validators_1 = require("utils/form/validators");
var StyledHelperText = (0, styles_1.styled)(material_1.FormHelperText)(function () { return ({
    fontSize: 12,
    lineHeight: '14px',
    margin: 0,
    textAlign: 'center',
}); });
var NumberInput = function (_a) {
    var value = _a.value, onChange = _a.onChange, allowNegative = _a.allowNegative, allowEmptying = _a.allowEmptying, props = __rest(_a, ["value", "onChange", "allowNegative", "allowEmptying"]);
    return ((0, jsx_runtime_1.jsx)(react_number_format_1.NumericFormat, __assign({ thousandSeparator: ",", fixedDecimalScale: true, decimalScale: 2, allowNegative: !!allowNegative, autoComplete: "off", isAllowed: function (_a) {
            var floatValue = _a.floatValue;
            return !floatValue || floatValue >= 0 || !!allowNegative;
        }, value: value, onValueChange: function (_a) {
            var floatValue = _a.floatValue;
            return onChange(floatValue !== null && floatValue !== void 0 ? floatValue : (allowEmptying ? undefined : 0));
        }, customInput: TextField_1.DummyTextField, color: "primary" }, props, { error: !!props.error, helperText: props.error || props.helperText })));
};
exports.PERCENT_DEFAULT_PROPS = {
    suffix: '%',
    decimalScale: 1,
    isAllowed: function (_a) {
        var floatValue = _a.floatValue;
        return !floatValue || (floatValue <= 100 && floatValue >= 0);
    },
};
exports.PercentInput = (0, DefaultPropsHoC_1.default)(NumberInput, exports.PERCENT_DEFAULT_PROPS);
var PercentFormInput = function (_a) {
    var _b = _a.input, value = _b.value, onChange = _b.onChange, onBlur = _b.onBlur, onFocus = _b.onFocus, meta = _a.meta, props = __rest(_a, ["input", "meta"]);
    var error = (0, validators_1.getTextFieldErrorToShow)(meta);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(exports.PercentInput, __assign({ onChange: onChange, onBlur: onBlur, onFocus: onFocus, allowEmptying: true, value: value, error: !!error }, props)), error && (0, jsx_runtime_1.jsx)(StyledHelperText, __assign({ error: true }, { children: error }))] }));
};
exports.PercentFormInput = PercentFormInput;
var NumberFormInput = function (_a) {
    var _b = _a.input, value = _b.value, onChange = _b.onChange, onBlur = _b.onBlur, onFocus = _b.onFocus, meta = _a.meta, props = __rest(_a, ["input", "meta"]);
    var error = (0, validators_1.getTextFieldErrorToShow)(meta);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(NumberInput, __assign({ onChange: onChange, onBlur: onBlur, onFocus: onFocus, allowEmptying: true, value: value, error: !!error }, props)), error && (0, jsx_runtime_1.jsx)(StyledHelperText, __assign({ error: true }, { children: error }))] }));
};
exports.NumberFormInput = NumberFormInput;
exports.default = NumberInput;
